import {populateGeneralData} from "../../utils/populateGeneralData";
import {addPostDate} from "../../utils/addPostDate";
import {isValidUrl} from "../../utils/isValidUrl";
import {positionEventContents} from "../event/positionEventContents";
import {checkIfAlreadyProsted} from "../../prost/checkIfAlreadyProsted";
import {checkIfAlreadyFavourites} from "../../favourites/checkIfAlreadyFavourites";

export { getAuthor } from "../../author/getAuthor";
export { addImpression } from "../../utils/addImpression";
export { decorateDateString } from "../../utils/decorateDateString";

function positionBlogContents(jsonObj, lazyLoadOnThisPage,modalElement=null) {
    const data = $.parseJSON(jsonObj);
    let elements = communityType === 5 ? data.blog_elements : data.timeline_elements;
    const blogElements = data.blog_elements;
    if (modalElement) {
        elements = data.blog_elements;
    }
    $.each(elements, (key, value) => {
        let timeLineElement = communityType === 5 ? value : blogElements[value.post_id];
        const container = $(`#${value.id}.timeline_entry`);
        if (modalElement) {
            timeLineElement = value;
        }
        if (timeLineElement.active.toString() !== "1" || (!container?.length || container[0]?.classList.contains("already-loaded"))) {
            container.remove();
            return;
        }else{
            container?.[0]?.classList.add("already-loaded");

        }

        let clonedBox = $(".blog_box_prototype").clone().appendTo(container);
        if (modalElement) {
            clonedBox = modalElement;
        }
        clonedBox.removeClass("hidden");
        clonedBox.removeClass("blog_box_prototype");
        container.find(".js-spinner").hide();

        let imgSrc = "";

        if (timeLineElement.image && timeLineElement.image.trim() !== "") {
            if (isValidUrl(timeLineElement.image)) {
                // Full valid URL
                imgSrc = timeLineElement.image;
            } else {
                // Not a URL, assume it's a filename and prepend path
                imgSrc = "/userdata/blog/resize/" + timeLineElement.image;
            }
        } else {
            // Fallback default image
            imgSrc = "/layout/frontend/stiegl/dist/images/event-blog-image.jpg";
        }

        clonedBox.find('.js-timeline-image').html(
            "<img loading='lazy' src='" + imgSrc +
            "' alt='" + (timeLineElement.description || "") +
            "' title='" + (timeLineElement.description || "") + "' />"
        );

        clonedBox.find(".js-timeline-link").attr("href", `/${siteCode}/${mainLanguageCode}/blog/post/${timeLineElement.slug}/`);
        if(!modalElement) {
            initBlogModalBox(container, timeLineElement,key);
        }
        clonedBox.find(".js-author-line .js-date").text(decorateDateString(timeLineElement.validity_from));
        clonedBox.find(".js-headline").text(timeLineElement.description);
        clonedBox.find(".js-post-date").text(decorateDateString(value.post_date));


        let contentPreview = $( $.parseHTML(
            timeLineElement.content.replace(/<br\s*\/?>/gi, " ")
        ) ).text();

        if (contentPreview.length > 250) {
            contentPreview = contentPreview.substring(0, 247) + " ..";
        }

        clonedBox.find(".js-link-preview-text").text(contentPreview);


        populateGeneralData(clonedBox,timeLineElement);

        if (timeLineElement.author) {
            getAuthor(timeLineElement, value);
        }

        addImpression(value.id);
        enableSmilies(clonedBox.find(".smiley_input"));
    });

    lazyLoad = lazyLoadOnThisPage;
}
function initBlogModalBox(element, data,key) {
    if (!element?.[0]) return;
    const $modal= $('.js-blog-modal');
    let isOpen=false;
    element[0].addEventListener('click', function (event) {
        if (event.target.matches('.js-timeline-link')) {
            event.preventDefault();
            const url = event.target.getAttribute('href');
            console.log(url);
            history.pushState({ modal: true }, '', url);
            $modal.find('.js-modal-content').empty();
            isOpen=true;
            $.ajax({
                type: "get",
                url: url,
                success: function (output) {
                    // Create a temporary DOM element to parse the fetched HTML
                    var tempDiv = $('<div>').html(output);

                    // Find the element with class .blog_page
                    var blogContent = tempDiv.find('.blog_entry');
                    blogContent.attr('id', key);

                    $modal.find(".js-modal-title").text(data.description);
                    // Insert the HTML into the target div
                    $modal.find('.js-modal-content').empty().append(blogContent);
                    MagicZoom.start();
                    $modal.modal("show");
                },
                error: function (xhr, status, error) {
                    console.error("Error fetching blog:", status, error);
                }
            });
        }
    });

    $modal.on('hidden.bs.modal', function (e) {
        if (isOpen && history.state && history.state.modal) {
            history.back();
            $modal.find('.js-modal-content').empty();
            isOpen=false;
        }
    });
    window.addEventListener('popstate', function(event) {
        if ($modal.hasClass('in')) {
            $modal.modal('hide');
        }
    });
}



export default positionBlogContents
